export default __webpack_public_path__ + "static/media/ayushi1.cf9494b7.png";